import { SearchEvent } from '@df/search/search-event';
import { SearchResult } from '@df/search/search-result';

export class SearchResultEvent extends SearchEvent {
    /**
     * Event constructor
     */
    constructor(
        searchId,
        public result: SearchResult | undefined
    ) {
        super(searchId);
    }
}
